import React from 'react';
import imagen1 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193418.jpg';
import imagen2 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193422.jpg';
import imagen3 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193423.jpg';
import imagen4 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193426.jpg';
import imagen5 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193430.jpg';
import imagen6 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193433.jpg';
import imagen7 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193439.jpg';
import imagen8 from '../imagenes/galeriaProyectos/seccionReformas/20240522_193445.jpg';
import '../estilos/galeria.css';
import img1 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154321 (1).jpg';
import img2 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154326.jpg';
import img3 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154329 (1).jpg';
import img4 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154333.jpg';
import img5 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154339.jpg';
import img6 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154351.jpg';
import img7 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154404.jpg';
import img8 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154425.jpg';
import img9 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154536.jpg';
import img10 from '../imagenes/galeriaProyectos/seccionRef2/20240711_154343.jpg';

function GaleriaReformas() {
  return (
    <div className="container-fluid mt-5 contenedor-proyectos-ref d-flex flex-column text-center justify-content-center">
      <h2 className="mb-5 mt-3 titulo">Reforma En L'Eliana Antes De Empezar</h2>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen1} alt="Imagen 1" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen2} alt="Imagen 2" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen3} alt="Imagen 3" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen4} alt="Imagen 4" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen5} alt="Imagen 5" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen6} alt="Imagen 6" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen7} alt="Imagen 7" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={imagen8} alt="Imagen 8" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
      </div>
      <h2 className="mb-5 mt-5 titulo">Reforma Terminada</h2>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img1} alt="Imagen 1" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img2} alt="Imagen 2" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img3} alt="Imagen 3" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img4} alt="Imagen 4" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img5} alt="Imagen 5" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img6} alt="Imagen 6" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img7} alt="Imagen 7" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img8} alt="Imagen 8" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img9} alt="Imagen 9" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
        <div className="col-12 col-md-6 col-lg-3 mb-4">
          <img src={img10} alt="Imagen 10" className="img-fluid w-100" style={{ height: '300px', objectFit: 'cover' }} />
        </div>
      </div>
    </div>
  );
}

export default GaleriaReformas;